<template>
  <div :class="classObject">
      <card
        v-for="(item, index) in content" :key="index"
        clickable="true"
        :id="item.category + '-card-' + (index + 1)"
        :category="item.category"
        :value="item.value"
        @click="handleClick(index, item.category)"
        :limit="limit"
        @click-selected="limitClick"
        :numberSelected="numberSelected"
        :output="item.alt">
        <sb-image v-if="item.img" :src="item.img" :alt="item.alt"></sb-image>
        <p class="h4" v-else>{{item.alt}}</p>
      </card>
  </div>
</template>

<script>
import Card from '../Card.vue';
import SbImage from '../SbImage/SbImage';
import { mapMutations } from 'vuex';

export default {
  name: 'Gallery',
  components: {
    Card,
    SbImage,
  },
  props: ['content', 'category', 'value', 'grid', 'isRadio', 'limit', 'store'],
  data() {
    return {
      numberSelected: 0,
      classObject: [
        this.grid,
        { 'md:py-3': this.store === 'priorities' }
      ]
    }
  },
  methods: {
    ...mapMutations([
      'setIntegrations',
      'removeAll'
    ]),
    handleClick(index, category) {
      if (this.isRadio) {
        this.removeAll([category + '-card-' + (index + 1), category])
      }
    },
    limitClick(isSelected) {
      if (this.limit) {
        if (isSelected) {
          this.numberSelected++;
        } else {
          this.numberSelected--;
        }
      }
    }
  },
  mounted() {
    this.setIntegrations();
  }
}
</script>

<style scoped>
  .grid-x5 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 15px;
  }

  @media (min-width: 768px) {
    .grid-x5 {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
  }

  .grid-x4 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 15px;
  }

  .grid-x3 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
  }

  @media (min-width: 576px) {
    .grid-x3 {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media (min-width: 768px) {
    .md\:py-3 {
      padding-left: 4rem;
      padding-right: 4rem;
    }
  }

  .card {
    text-align: center;
    background-color: #efefef;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 150px;
    position: relative;
    z-index: 1;
  }

  object:not([width]) {
    width: 100%;
    height: 100%;
  }

</style>